<template>
  <div id="ihealth-layout" class="theme-blue">
  
  <!-- Main body area -->
  <div class="main p-2 py-3 p-xl-5 ">
      <div class="body d-flex p-0 p-xl-5">
          <div class="container-xxl">
  
              <div class="row g-0">
                  <div class="col-lg-6 d-none d-lg-flex justify-content-center align-items-center rounded-lg auth-h100">
                      <div style="max-width: 25rem;">
                          <div class="text-center mb-5">
                            <i class="icofont-ui-message secondary-color" style="font-size: 90px;"></i>
                          </div>
                          <div class="mb-5">
                            <h2 class="color-900 text-center">İlk girişdə burada sizin QR çıxacaq və bunu siz Authenticator tətbiqləri ilə skan edərək sistemə giriş icazəsi ala biləcəksiniz.</h2>
                          </div>
                          
                          <!-- Image block -->
                          <div class="">
                            <canvas ref="qrCanvas"></canvas>
                          </div>
                      </div>
                  </div>
  
                  <div class="col-lg-6 d-flex justify-content-center align-items-center border-0 rounded-lg auth-h100">
                      <div class="w-100 p-3 p-md-5 card border-0 bg-dark text-light" style="max-width: 32rem;">
                          <!-- Form -->
                          <form class="row g-1 p-3 p-md-4" @submit.prevent="signIn" id="sign" ref="form">
                              <!-- Msisdn -->
                              <div class="col-12">
                                  <div class="mb-2">
                                      <label class="form-label">Username</label>
                                      <input v-model="username" v-validate="{required: true}" name="username" type="text" class="form-control form-control-lg" placeholder="username">
                                      <span class="inputError">{{ errors.first('username') }}</span>
                                  </div>
                              </div>
  
                              <!-- Password -->
                              <div class="col-12">
                                  <div class="mb-2">
                                      <div class="form-label">
                                          <span class="d-flex justify-content-between align-items-center">
                                              Password
                                              <!-- ForgotPassword -->
                                              <!-- <a @click.prevent="redirectToResetPassword" class="forgotpassword">Forgot Password?</a> -->
                                          </span>
                                      </div>
                                      <input v-model="password" v-validate="{ required: true, min: 3}" name="password" type="password" class="form-control form-control-lg" placeholder="password  ">
                                      <span class="inputError">{{ errors.first('password') }}</span>
                                  </div>
                              </div>
  
                              <div class="col-12 text-center mt-4">
                                <button type="submit" :disabled="loading" class="btn btn-lg btn-block btn-light lift text-uppercase" atl="signin">SIGN IN</button>
                              </div>
                          </form>
                          <!-- End Form -->
                          
                      </div>
                  </div>
              </div>
              
          </div>
      </div>
  
  </div>
  
  </div>
  </template>
  <script>
    import axios from "axios"
    import store from '../store/'
    import QRCode from "qrcode";
    
    export default {
      // eslint-disable-next-line vue/multi-word-component-names
      name: 'Login',
      data: ()=>({
        username : '',
        password : '',
        authUrl: '',
        loading: false,
      }),
      methods: {
        generateQRCode() {
          const canvas = this.$refs.qrCanvas;
          console.log(this.authUrl)
          QRCode.toCanvas(canvas, this.authUrl, { width: 200 }, (error) => {
            if (error) {
              console.error("QR kod yaradılarkən səhv:", error);
            }
          });

        },
        async signIn(){
          const validForm = await this.formIsValid
          if(validForm){
            this.loading = true
            axios.post(store.getters.getUrl+'/Auth/Login', {username: this.username, password: this.password, enable2FA:false})
            .then(response => {
              console.log(response.data.result);
              if(response.data.result === true){
                this.loading = false;
                this.$router.push({ name: 'otp', params: { user: this.username } })
              }
              else {
                this.authUrl = response.data.result;
                this.generateQRCode();
                this.loading = false;

              }
              // if(response.data.isError == null){
              //   this.$toast.success('Uğurlu giriş')
              
              //   user.dispatch('updateLogin',{expires:1, user:response.data.result})
  
              //   this.loading = false
              //   location.href='/'
              // }
            })
            .catch(error=> {
              if(error.response.status === 404){
                this.$toast.error('İstifadəçi adı və ya parol səhvdir.')
              }
              this.loading = false
            })
          } 
          else {
            this.$toast.error('Səvhlikləri düzəldin!')
            this.loading = false
          }
        },
        // redirectToResetPassword() {
        //   console.log('redirect')
        //   if (this.username.length === 12)
        //     this.$router.push({ name: 'forgotPassword', params: {msisdn: this.username}})
        //   else
        //     this.$toast.error('12 rəqəmli Msisdn-ı daxil edin!')
        // }
      },
      computed : {   
        formIsValid(){
          // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
          return new Promise(async (resolve, reject) => {
            try {
              const valid = await this.$validator.validate();
              resolve(valid);
            } catch (error) {
              reject(error);
            }
          });
        }
      },
    }
  </script>
  <style>
    .inputError {
      color: #ff0000;
      font-weight: bold;
    }
  
    .forgotpassword {
      background: transparent;
      border: none;
    }
  
    .forgotpassword:hover {
      color: #ffb62d;
    }
    canvas {
      display: block;
      margin: 20px auto;
    }
  </style>